import React from 'react';
import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component';
import { ApplicationRoutes } from 'containers/System/routes';
import bannerLR from './images/bannerLR.jpg';
import banner from './images/banner.jpg';
import bannerRes from './images/banner-res.jpg';
import bannerResLR from './images/banner-resLR.jpg';
const handleTab1Click = () => {
    const tab2Header = document.getElementById('tab2_header');
    const tab2Content = document.getElementById('tab2_content');
    if (tab2Header) {
        tab2Header.classList.remove('highlight2');
    }
    if (tab2Content) {
        tab2Content.classList.remove('card-tab2-active');
    }
    const tab1Header = document.getElementById('tab1_header');
    const tab1Content = document.getElementById('tab1_content');
    if (tab1Header) {
        tab1Header.classList.add('highlight1');
    }
    if (tab1Content) {
        tab1Content.classList.add('card-tab1-active');
    }
};
const handleTab2Click = () => {
    const tab1Header = document.getElementById('tab1_header');
    const tab1Content = document.getElementById('tab1_content');
    if (tab1Header) {
        tab1Header.classList.remove('highlight1');
    }
    if (tab1Content) {
        tab1Content.classList.remove('card-tab1-active');
    }
    const tab2Header = document.getElementById('tab2_header');
    const tab2Content = document.getElementById('tab2_content');
    if (tab2Header) {
        tab2Header.classList.add('highlight2');
    }
    if (tab2Content) {
        tab2Content.classList.add('card-tab2-active');
    }
};
const Banner = ({ scrollPosition }) => (React.createElement("div", { className: "container-fluid no-pad banner-por" },
    React.createElement("div", { className: "banner-bg" },
        React.createElement("div", { style: {
                position: 'absolute', width: '37%', marginLeft: '7%', marginTop: '10%',
            } },
            React.createElement("div", { className: "card" },
                React.createElement("div", { className: "card-header" },
                    React.createElement("div", { id: "tab1_header", className: "highlight1", onClick: handleTab1Click, style: { background: 'rgba(224, 223, 226, .7)', color: '#1D4358' } }, "Appearance Coverage"),
                    React.createElement("div", { id: "tab2_header", onClick: handleTab2Click, style: { background: 'rgba(247, 247, 248, .7)', color: '#ff7200' } }, "Freelance Work")),
                React.createElement("div", { id: "tab1_content", className: "card-content card-tab1-content card-tab1-active" },
                    React.createElement("h2", { style: { color: '#1D4358' } }, "Schedule Court Appearance Coverage"),
                    React.createElement("p", { style: { marginBottom: '20px' } }, "Get more done with the right appearance attorney."),
                    React.createElement("p", { style: { paddingBottom: '12%' } }, "Whether it's a routine or emergency hearing or deposition, Attorneys in Motion is where law firms go to get appearance coverage."),
                    React.createElement("a", { href: ApplicationRoutes.clientSignUp, className: "card-button" }, "Learn More")),
                React.createElement("div", { id: "tab2_content", className: "card-content card-tab2-content" },
                    React.createElement("h2", null, "Hire a Contract Attorney For Project-Based Legal Writing"),
                    React.createElement("p", { style: { marginBottom: '20px' } }, "Our project-based legal work platform gives you the tools you need to scale and grow your law firm."),
                    React.createElement("p", { style: { paddingBottom: '12%' } }, "Hire an attorney per project or per hour for long-term, ongoing work."),
                    React.createElement("a", { href: "https://lawbeez.com", className: "card-button", target: "_blank", rel: "noreferrer" }, "Learn More")))),
        React.createElement(LazyLoadImage, { alt: "Local Counsel Attorneys", title: "Local Counsel Attorneys", scrollPosition: scrollPosition, src: banner, placeholderSrc: bannerLR })),
    React.createElement("div", { className: "banner-bg-res" },
        React.createElement(LazyLoadImage, { alt: "Appearance Attorney Services", title: "Appearance Attorney Services", scrollPosition: scrollPosition, src: bannerRes, placeholderSrc: bannerResLR }))));
export default trackWindowScroll(Banner);
